import { ComponentProps, useCallback } from 'react'

import { matchRoutes } from 'react-router-dom'

import { JourneyData, JourneyRoute, JourneyScope } from '@cash-web/shared-journey-data-access-context'

import { JourneyRouter } from '../JourneyRouter'

/**
 * Returns the merged route scope config and journey scope config for a given journey
 * @param router - The router object
 * @param journeyData - The journey data
 * @returns The route journey scope config
 */
export const useGetRouteScopeConfig = ({ router }: ComponentProps<typeof JourneyRouter>) => {
  return useCallback(
    (journeyData: JourneyData): JourneyScope & JourneyRoute => {
      const matches = matchRoutes(router.routes, journeyData.path)
      const routeConfig = matches?.[matches.length - 1]?.route as JourneyRoute
      const modalVariant = routeConfig?.modalVariant ?? journeyData.opts?.scope?.['modalVariant']
      const target = modalVariant === 'fullscreen' ? 'fullscreen' : routeConfig.target ?? 'modal' // default modal  if no target set

      return {
        ...(journeyData.opts?.scope as JourneyScope),
        ...routeConfig,
        target,
      }
    },
    [router.routes]
  )
}
